import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import cookie from 'react-cookies'
import { WEB_BASE_URL } from '../../../unified/webbase';

export default function UpdateWhiteLabelModal({ show, onClose, currentData, onUpdate }) {
    const token = cookie.load("token")

    const [formData, setFormData] = useState({
        faqUrl: '',
        supportEmail: '',
        supportPhoneNumber: ''
    });

    useEffect(() => {
        if (currentData) {
            setFormData({
                faqUrl: currentData.faqUrl || '',
                supportEmail: currentData.supportEmail || '',
                supportPhoneNumber: currentData.supportPhoneNumber || ''
            });
        }
    }, [currentData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const iid = toast.loading("Please wait...");
        const submitData = new FormData();
        
        // Add all required fields
        submitData.append('appName', currentData.appName);
        submitData.append('businessName', currentData.businessName);
        submitData.append('appColour', currentData.appColour);
        submitData.append('faqUrl', formData.faqUrl);
        submitData.append('supportEmail', formData.supportEmail);
        submitData.append('supportPhoneNumber', formData.supportPhoneNumber);
        
        // Add the image URL if it exists
        if (currentData.imageUrl) {
            submitData.append('file', currentData.imageUrl);
        }
    
        try { 
          axios
          .post(WEB_BASE_URL + "/onboarding/submit-kyc", submitData, {
            headers: {
              authorization: token,
            },
          })
          .then((res) => {
            if (res.data.status === "2000") {
              // Update the parent component's state with all fields
              onUpdate({
                ...currentData,
                faqUrl: formData.faqUrl,
                supportEmail: formData.supportEmail,
                supportPhoneNumber: formData.supportPhoneNumber
              });
              onClose();
              toast.update(iid, {
                render: res.data.message,
                type: "success",
                isLoading: false,
              });
            } else {
              toast.update(iid, {
                render: res.data.message || 'Error updating information',
                type: "error",
                isLoading: false,
              });
            }
          })
          .catch((err) => {
            console.log(err);
            toast.update(iid, {
              render: err.response?.data?.message || 'Error updating information',
              type: "error",
              isLoading: false,
            });
          });
        } catch (error) {
          toast.update(iid, {
            render: 'Error submitting request',
            type: "error",
            isLoading: false,
          });
          console.error('Error:', error);
        }
    };

    if (!show) return null;

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Update White Label Information</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={onClose}
                            aria-label="Close"
                        ></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">FAQ URL</label>
                                <input
                                    type="url"
                                    className="form-control"
                                    name="faqUrl"
                                    value={formData.faqUrl}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Support Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="supportEmail"
                                    value={formData.supportEmail}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Support Phone Number</label>
                                <input
                                    type="tel"
                                    className="form-control"
                                    name="supportPhoneNumber"
                                    value={formData.supportPhoneNumber}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                className="btn btn-primary"
                            >
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}